/**
 * MessageBubble Component
 * 
 * Displays a single chat message with delivery/read status
 */

import { ChatMessage } from '@/store/chat';
import { formatTime } from '@/lib/utils';

interface MessageBubbleProps {
  message: ChatMessage;
  isOwn: boolean;
}

export default function MessageBubble({ message, isOwn }: MessageBubbleProps) {
  return (
    <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'} mb-3`}>
      <div className={`max-w-[75%] ${isOwn ? 'items-end' : 'items-start'} flex flex-col`}>
        {!isOwn && (
          <div className="text-xs text-muted-foreground mb-1 px-1">
            {message.senderName}
          </div>
        )}
        
        <div
          className={`rounded-2xl px-4 py-2 ${
            isOwn
              ? 'bg-primary text-primary-foreground rounded-br-none'
              : 'bg-muted text-foreground rounded-bl-none'
          }`}
        >
          <p className="text-sm whitespace-pre-wrap break-words">{message.message}</p>
        </div>

        <div className="flex items-center gap-1 mt-1 px-1">
          <span className="text-xs text-muted-foreground">
            {formatTime(message.timestamp)}
          </span>
          
          {isOwn && (
            <span className="text-xs text-muted-foreground">
              {message.localOnly ? (
                <span className="text-orange-500">⏳</span>
              ) : message.readAt ? (
                <span className="text-blue-500">✓✓</span>
              ) : message.deliveredAt ? (
                <span>✓✓</span>
              ) : (
                <span>✓</span>
              )}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}


















